import vueRouter from 'vue-router'
import Vue from 'vue'
Vue.use(vueRouter)
import home from '@/components/home'
const router = new vueRouter({
	routes:[
		{
			name:'home',
			path:'/',
			component:home
		},
		{
			name:'devlop',
			path:'/devlop',
			component:() => import('@/components/devlop')
		},
		{
			name:'about',
			path:'/about',
			component:() => import('@/components/about')
		},
		{
			name:'invite',
			path:'/invite',
			component:() => import('@/components/invite')
		}
	]
})
router.beforeEach((to,from,next)=>{
	if(to.name != from.name){
		next();
	}
})
export default router